import PropTypes from 'prop-types';
import React from 'react';
import { Button } from 'react-bootstrap';

import ProposalDetail from './ProposalDetail';

class ProposalOverview extends React.Component {
  constructor(props) {
    super(props);
    this.handleRefreshRequest = this.handleRefreshRequest.bind(this);
  }
  componentWillMount() {
    this.props.requestProposals(this.props.tourId);
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.tourId !== this.props.tourId) {
      this.props.requestProposals(nextProps.tourId);
    } else if (nextProps.needFetch) {
      this.props.requestProposals(nextProps.tourId);
    }
  }
  handleRefreshRequest(e) {
    this.props.requestProposals(this.props.tourId);
  }

  render() {
    if (this.props.needFetch || this.props.isFetching) {
      return <div>Loading...</div>;
    }
    if (this.props.proposals.length !== 0) {
      const proposalDetails = this.props.proposals.map(proposal => (
        <ProposalDetail
          key={proposal.id}
          addBidNote={this.props.addBidNote}
          editBid={this.props.editBid}
          proposal={proposal}
          removeBid={this.props.removeBid}
          sendBid={this.props.sendBid}
          sendProposal={this.props.sendProposal}
          user={this.props.user}
        />
      ));
      return (
        <div>
          <p>You can send bid requests to a brand rep or to individual properties.</p>
          <p>
            Click on the{' '}
            <Button bsStyle="info" disabled>
              <i className="fa fa-pencil fa-lg" /> Manage Bid
            </Button>
            to see bid details, add notes for this property only, or send bid request directly to
            this property.
          </p>
          {proposalDetails}
        </div>
      );
    }
    return (
      <div>
        No proposals are available. Please select hotels before trying to request bids.
        <Button onClick={this.handleRefreshRequest} bsStyle="primary">
          Refresh
        </Button>
      </div>
    );
  }
}

ProposalOverview.propTypes = {
  tourId: PropTypes.number.isRequired,
  proposals: PropTypes.arrayOf(PropTypes.object).isRequired,
  needFetch: PropTypes.bool.isRequired,
  addBidNote: PropTypes.func.isRequired,
  editBid: PropTypes.func.isRequired,
  removeBid: PropTypes.func.isRequired,
  requestProposals: PropTypes.func.isRequired,
  sendBid: PropTypes.func.isRequired,
  sendProposal: PropTypes.func.isRequired,
};

ProposalOverview.defaultProps = {
  proposals: [],
};
export default ProposalOverview;



// WEBPACK FOOTER //
// src/routes/tours/components/ProposalOverview.js